import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useQuery} from "@tanstack/react-query";
import { useForm } from "react-hook-form";
import { get, post, del } from "@utils/axios_api";

const fetchLectureList = async (params) => {
  const response = await get("/admin/lecture/lectureList", { params });
  return response;
};
const fetchCategoryList = async () => {
  const response = await get("/common/categoryList");
  return response;
};
const fetchEduTypeList = async (groupCode) => {
  const response = await post("/common/codeList", { groupCode });
  return response;
};

export function useLecture() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedItems, setSelectedItems] = useState([]);

  const methods = useForm({
    defaultValues: {
      searchCnd: "",
      searchWrd: "",
      catgRegYear: "",
      eduCategoryId: "",
      comdCode: "",
    },
    shouldFocusError: false, // Focus 방지(포커스 구현시 React ref 구현 해야함)
  });
  
  const searchCnd = searchParams.get("searchCnd") || "";
  const searchWrd = searchParams.get("searchWrd") || "";
  const catgRegYear = searchParams.get("catgRegYear") || "";
  const eduCategoryId = searchParams.get("eduCategoryId") || "";
  const comdCode = searchParams.get("comdCode") || "";
  const pageIndex = parseInt(searchParams.get("pageIndex") || "1", 10);
  const recordCountPerPage = 10;

  const queryParam = {
    searchCnd, searchWrd,
    catgRegYear, eduCategoryId, comdCode,
    pageIndex, recordCountPerPage,
  };

  const { data:lectureList, refetch } = useQuery({
    queryKey: ["selectAdminLectureList", JSON.stringify(queryParam)],
    queryFn: () => fetchLectureList(queryParam),
    keepPreviousData: true,
  });

  const { data:categoryList } = useQuery({
    queryKey: ["selectAdminCategoryList"],
    queryFn: () => fetchCategoryList(),
    staleTime: Infinity,
  });

  const { data:eduTypeList } = useQuery({
    queryKey: ["selectAdminEduTypeList", "EDU_TYPE" ],
    queryFn: () => fetchEduTypeList("EDU_TYPE"),
    staleTime: Infinity,
  });

  const refreshList = () => {
    refetch();
  };

  const onSubmit = (values) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("searchCnd", values.searchCnd || "");
    newParams.set("searchWrd", values.searchWrd || "");
    newParams.set("catgRegYear", values.catgRegYear || "");
    newParams.set("eduCategoryId", values.eduCategoryId || "");
    newParams.set("comdCode", values.comdCode || "");
    newParams.set("pageIndex", "1");
    setSearchParams(newParams);
  };

  const handlePageChange = (targetPage) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("pageIndex", targetPage);
    setSearchParams(newParams);
  };

  const handleSelectAll = (e) => {
    if (!lectureList || !lectureList.resultList) return;
    const { checked } = e.target;
    if (checked) {
      const allIds = lectureList.resultList.map((item) => item.lectureId);
      setSelectedItems(allIds);
    } else {
      setSelectedItems([]);
    }
  };

  const handleSelectItem = (lectureId) => {
    if (selectedItems.includes(lectureId)) {
      setSelectedItems(selectedItems.filter((id) => id !== lectureId));
    } else {
      setSelectedItems([...selectedItems, lectureId]);
    }
  };

  const resetSearch = () => {
    if (!window.confirm('조회 조건을 초기화 하시겠습니까?')) return;
    methods.reset({
      searchCnd: "",
      searchWrd: "",
      catgRegYear: "",
      eduCategoryId: "",
      comdCode: "",
    });
    setSearchParams(new URLSearchParams());
  };

  const handleDelete = async (e) => {
    e.preventDefault();
    if (!selectedItems.length) {
      alert("삭제할 항목을 선택해주세요.");
      return;
    }

    const isConfirmed = window.confirm("정말 삭제하시겠습니까?");
    if (!isConfirmed) return;

    try {
        const response = await del("/admin/lecture/deleteLecture", {data: {lectureIdList: selectedItems}})
        alert(response?.message);
        refetch();
        setSelectedItems([]);
      } catch (err) {
        console.error(err);
        alert("삭제 실패");
      }
    
  };



  // 체크 여부
  const isAllChecked = !!(lectureList?.resultList?.length && selectedItems.length === lectureList?.resultList?.length);

  return {
    methods, lectureList, categoryList, eduTypeList,
    selectedItems, isAllChecked, onSubmit,
    handlePageChange, handleSelectAll, handleSelectItem, handleDelete, resetSearch,
    pageIndex, recordCountPerPage,
    refetch, refreshList,
  };
}
